var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66602 6.4445C4.66602 5.97295 4.85334 5.52071 5.18678 5.18727C5.52022 4.85383 5.97246 4.6665 6.44402 4.6665H12.2213C12.4548 4.6665 12.686 4.71249 12.9018 4.80185C13.1175 4.8912 13.3135 5.02217 13.4786 5.18727C13.6437 5.35237 13.7747 5.54838 13.864 5.76409C13.9534 5.97981 13.9993 6.21101 13.9993 6.4445V12.2218C13.9993 12.4553 13.9534 12.6865 13.864 12.9022C13.7747 13.118 13.6437 13.314 13.4786 13.4791C13.3135 13.6442 13.1175 13.7751 12.9018 13.8645C12.686 13.9538 12.4548 13.9998 12.2213 13.9998H6.44402C6.21053 13.9998 5.97932 13.9538 5.7636 13.8645C5.54789 13.7751 5.35188 13.6442 5.18678 13.4791C5.02168 13.314 4.89071 13.118 4.80136 12.9022C4.71201 12.6865 4.66602 12.4553 4.66602 12.2218V6.4445Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.67467 11.158C2.47023 11.0415 2.30018 10.873 2.18172 10.6697C2.06325 10.4663 2.00057 10.2353 2 10V3.33333C2 2.6 2.6 2 3.33333 2H10C10.5 2 10.772 2.25667 11 2.66667",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyDark);
export default __webpack_public_path__ + "static/media/copyDark.59bc38db90d2bd2643f1f0a978844096.svg";
export { ForwardRef as ReactComponent };